var styleDataHash = "c761fa99";
const injectCss = () => {
  var css = `.XwDkb{display:flex;flex-direction:row;justify-content:space-between}[dir] .XwDkb{padding-bottom:10px;padding-top:10px}[dir=ltr] .XwDkb{padding-left:21px;padding-right:23px}[dir=rtl] .XwDkb{padding-left:23px;padding-right:21px}.tPPru{color:#bdbdbd;font-size:16px}[dir] .tPPru{cursor:pointer;padding:0 5px}._4guUN:hover{opacity:.5}.N0XsW{display:inline-block}.lRd0F{box-sizing:border-box;font-size:20px;height:37px;width:37px}[dir] .lRd0F{cursor:pointer;margin:3px;padding:5px;text-align:center}[dir=ltr] .lRd0F{float:left}[dir=rtl] .lRd0F{float:right}[dir] .lRd0F:hover{background:#efefef}.ehED9{color:var(--ricos-settings-text-color,#000);display:flex;font-size:14px;font-weight:300;justify-content:space-between}[dir] .ehED9{margin-bottom:11px}[dir=ltr] .ehED9,[dir=rtl] .ehED9{padding-left:17px;padding-right:17px}.PPK21{font-family:cursive!important;height:265px;min-width:272px;width:calc(100% - 12px)}[dir=ltr] .PPK21{margin-left:6px}[dir=rtl] .PPK21{margin-right:6px}.R8ory{color:rgba(0,0,0,.4);height:14px;width:auto}[dir] .R8ory{padding-top:3px}._3d-QK{width:4px}[dir] ._3d-QK{background:#b2b2b2;border-radius:4px;cursor:pointer}[dir=ltr] ._3d-QK{margin-left:1px}[dir=rtl] ._3d-QK{margin-right:1px}[dir] ._3d-QK:hover{background:#000}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var emoji_preview_modal_default = {
  "emojiPreviewModal_emoji_icons_container": "XwDkb",
  "emojiPreviewModal_nav_icon": "tPPru",
  "emojiPreviewModal_emoji_icon": "_4guUN",
  "emojiPreviewModal_emoji_group": "N0XsW",
  "emojiPreviewModal_emoji": "lRd0F",
  "emojiPreviewModal_headerTitle": "ehED9",
  "emojiPreviewModal_emojis_groups_container": "PPK21",
  "emojiPreviewModal_JoyPixelsIcon": "R8ory",
  "emojiPreviewModal_scrollbar_thumb": "_3d-QK"
};
export {
  emoji_preview_modal_default as default,
  injectCss
};
//# sourceMappingURL=emoji-preview-modal-scss.js.map
